import type { ApplicableVariation, Applicant, PayedVisaForm, VisaForm, VisaFormWithFiles } from "~/types";
import { calcAge } from "./date";

export function isVisaFormWithFiles(form: VisaForm): form is VisaFormWithFiles {
  return 'fileTransferMethod' in form;
}

export function isFormPayed(form: VisaForm): form is PayedVisaForm {
  return !!form.orderId;
}

export function getApplicableVariations(form: VisaForm): ApplicableVariation[] {
  const { product, applicants } = form;
  if (!product.variations) return [];

  const applicableVariation: ApplicableVariation[] = [];
  const relevantProductVariations = product.variations.filter(v => v.name != product.variation_name);
  for (const variation of relevantProductVariations) {
    if (variation.dependency == 'nationality') {
      for (const applicant of applicants) {
        if (!('nationality' in applicant.passport)) continue;
        if (variation.nationalities.includes(applicant.passport.nationality)) {
          applicableVariation.push({ ...variation, applicantId: applicant.id });
        }
      }
    }
    else if (variation.dependency == 'min_age') {
      for (const applicant of applicants) {
        if (!('dateOfBirth' in applicant.passport)) continue;
        if (calcAge(applicant.passport.dateOfBirth) > variation.age) {
          applicableVariation.push({ ...variation, applicantId: applicant.id });
        }
      }
    }
  }
  return applicableVariation;
}

export function getApplicant(form: VisaForm, id: Applicant['id']) {
  const applicant = form.applicants.find(applicant => applicant.id == id);
  if (!applicant) throw new Error(`Applicant with id ${id} not found`);
  return applicant;
}